import React, { useEffect, useState } from "react";
import { useSearchParams } from "next/navigation";
import AreaItem from "@/components/SearchPublicClass/AreaItem";
import useWindowDimensions from "./useWindowDimensions";
import RegionShowChildButton from "@/components/buttons/RegionShowChildButton";

const useFilterAreas = (setFilterForm, setArea, areas, setAreas) => {
  const width = useWindowDimensions();
  const searchParams = useSearchParams();
  const [expandedItems, setExpandedItems] = useState({});

  const handleAreas = (item, isChecked) => {
    setAreas((prevState) => {
      let newState = { ...prevState };

      // Toggle the selection state of the current item
      newState[item.value] = isChecked;

      // If the item has children, toggle their selection state too
      if (item.children && item.children.length > 0) {
        item.children.forEach((childItem) => {
          newState[childItem.value] = isChecked;

          // If the child item has grandchildren, toggle their selection state too
          if (childItem.children && childItem.children.length > 0) {
            childItem.children.forEach((grandchildItem) => {
              newState[grandchildItem.value] = isChecked;
            });
          }
        });
      }

      // Update parent items if necessary
      let parent = item.parent;
      while (parent) {
        const allChildChecked = parent.children.every(
          (childItem) => newState[childItem.value]
        );
        newState[parent.value] = allChildChecked;
        parent = parent.parent;
      }
      const selectedItems = Object.keys(newState).filter(
        (key) => newState[key]
      );

      setFilterForm &&
        setFilterForm((prevForm) => ({
          ...prevForm,
          bolge: selectedItems,
        }));
      if (width >= 1024 && setArea) {
        setArea(selectedItems);
      }

      return newState;
    });
  };

  useEffect(() => {
    const bolge = searchParams.get("bolge");

    if (!bolge) return;

    const bolgeArray = bolge.split(",").map((item) => item.trim());
    const areaObject = bolgeArray.reduce((acc, value) => {
      acc[value] = true;
      return acc;
    }, {});

    setFilterForm((prev) => ({
      ...prev,
      bolge: bolgeArray,
    }));

    setAreas(areaObject);
  }, []);

  const toggleItemExpansion = (itemValue) => {
    setExpandedItems((prev) => ({
      ...prev,
      [itemValue]: !prev[itemValue], // Toggle the current item's state
    }));
  };

  // const handleLabelClick = (item, checked) => {
  //   handleAreas(item, !checked);
  // };

  const renderItems = (items, parentItem) => {
    return (
      <>
        <div className="pl-2.5 w-full hidden lg:block">
          {items?.map((item) => {
            const itemId = `item-${item.value}`;
            item.parent = parentItem;
            const selects = areas;
            const checked =
              selects && selects[item.value] !== undefined
                ? selects[item.value]
                : false;
            const isExpanded = expandedItems[item.value] ?? false;
            return (
              <div key={item.value}>
                <div className="flex justify-between items-center">
                  <AreaItem
                    item={item}
                    itemId={itemId}
                    checked={checked}
                    handleAreas={handleAreas}
                    handleClick={() => toggleItemExpansion(item.value)}
                    marginStyle="my-1.5"
                    button={true}
                  />
                  {item?.children?.length > 0 && (
                    <RegionShowChildButton
                      checked={checked}
                      isExpanded={isExpanded}
                      onClick={() => toggleItemExpansion(item.value)}
                    />
                  )}
                </div>
                {isExpanded &&
                  item.children &&
                  item.children.length > 0 &&
                  renderItems(item.children, item)}
              </div>
            );
          })}
        </div>
        <div className="pl-2.5 w-full block lg:hidden">
          {items?.map((item) => {
            const itemId = `item-${item.value}`;
            item.parent = parentItem;
            const selects = areas;
            const checked =
              selects && selects[item.value] !== undefined
                ? selects[item.value]
                : false;
            const isExpanded = expandedItems[item.value] ?? false;
            return (
              <div key={item.value}>
                <div
                  className={`flex justify-between my-2 cursor-pointer rounded-md ${
                    item?.children?.length > 0 ? "border py-1 pl-1 pr-2.5" : ""
                  } ${
                    item?.children?.length > 0 && checked
                      ? "border-[#EC6803]"
                      : ""
                  } `}
                >
                  <AreaItem
                    item={item}
                    itemId={itemId}
                    checked={checked}
                    handleAreas={handleAreas}
                    handleClick={() => toggleItemExpansion(item.value)}
                    button={true}
                  />
                  {item?.children?.length > 0 && (
                    <RegionShowChildButton
                      checked={checked}
                      isExpanded={isExpanded}
                      onClick={() => toggleItemExpansion(item.value)}
                    />
                  )}
                </div>
                {isExpanded &&
                  item.children &&
                  item.children.length > 0 &&
                  renderItems(item.children, item)}
              </div>
            );
          })}
        </div>
      </>
    );
  };
  return { renderItems };
};

export default useFilterAreas;
